import * as THREE from 'three'
require('three-orbitcontrols');
import TextDrawer from './textDrawer';

import tidepool_negx_2 from '@/3dapps/skybox/tidepool/negx_2.jpg';
import tidepool_negy_2 from '@/3dapps/skybox/tidepool/negy_2.jpg';
import tidepool_negz_2 from '@/3dapps/skybox/tidepool/negz_2.jpg';
import tidepool_posx_2 from '@/3dapps/skybox/tidepool/posx_2.jpg';
import tidepool_posy_2 from '@/3dapps/skybox/tidepool/posy_2.jpg';
import tidepool_posz_2 from '@/3dapps/skybox/tidepool/posz_2.jpg';

export var scene;//相机
export var camera;//场景
export var renderer;//渲染器
export let controls;
export let currentMesh;
export let currentGroup;
export let currentPillarMesh = null;

let currentBaseBegin = 0;
let renderCount = -1;
let currentDraw = {
    width: 100,
    image: null
};

const material = new THREE.MeshPhongMaterial({
    reflectivity: 1,
    flatShading: true,
});

// -1标识一直渲染
// 0标识不渲染
// 1标识有限次数渲染
export function incRenderCount(){
    renderCount += 2;
}

function addSkyBox(scene, imgs) {
    scene.background = new THREE.CubeTextureLoader().load(imgs);
    renderCount += 2;
}

export function initThree(canvas) {
    let canvas_bound = canvas.getBoundingClientRect();
    scene = new THREE.Scene(); //相机

    //创建3D世界
    let w = canvas_bound.width;
    let h = canvas_bound.height;

    //创建渲染器
    renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        antialias: true, //抗锯齿
        preserveDrawingBuffer: true, //3D加上这个在缩略图中可以变成白色
    });
    renderer.setSize(w, h);
    renderer.setClearColor(new THREE.Color("#778A99")); //把渲染器的背景变成白色
    renderer.setPixelRatio(2);


    // 创建场景
    // 量纲，单位 1px 1m 1kg
    camera = new THREE.PerspectiveCamera(50, w / h, 0.1, 42000);

    //定义相机的x,y,z位置  
    camera.position.set(300.7320076063786, 141.55507047939082, 356.453822432378058);
    camera.lookAt(scene.position); //把相机的位置渲染到场景中


    //控制器，鼠标左键和右键，滑轮操作
    controls = new THREE.OrbitControls(camera, canvas);

    //是否可以缩放
    controls.enableZoom = true;
    //设置相机距离原点的最远距离
    controls.minDistance = 20;
    controls.maxDistance = 10000;


    controls.addEventListener("change", function () {
        renderCount += 2;
        // console.log(camera.position.x, camera.position.y, camera.position.z);
    });

    // let axesHelper = new THREE.AxesHelper(100);
    // scene.add(axesHelper);

    // 灯光
    function addLights() {
        // 平行光
        let dirLight = new THREE.DirectionalLight(0xffffff, 0.5);
        dirLight.position.set(-130, 130, 130); //注意：位置一定要调整好，否则会出现物体变成黑色的情况
        scene.add(dirLight);
        // let dirLightHelper = new THREE.DirectionalLightHelper(dirLight);
        // scene.add(dirLightHelper);

        // 平行光
        let dirLight3 = new THREE.DirectionalLight(0xffffff, 0.1);
        dirLight3.position.set(-130, -130, -130); //注意：位置一定要调整好，否则会出现物体变成黑色的情况
        scene.add(dirLight3);
        // let dirLightHelper2 = new THREE.DirectionalLightHelper(dirLight3);
        // scene.add(dirLightHelper2);

        // 环境光
        let ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
        scene.add(ambientLight);
    }
    addLights();

    addSkyBox(scene, [
        tidepool_negx_2,
        tidepool_posx_2,
        tidepool_posy_2,
        tidepool_negy_2,
        tidepool_negz_2,
        tidepool_posz_2,
    ]);

    //渲染场景
    function animate(now) {
        requestAnimationFrame(animate);
        // renderer.render(scene, camera);
        if (renderCount > 0) {
            renderer.render(scene, camera);
            renderCount = 0;
        } else if (renderCount < 0) {
            renderer.render(scene, camera);
        }
    }
    animate(0);
}

const canvas2 = document.createElement("canvas");
const context2 = canvas2.getContext("2d");

let textDrawer = new TextDrawer(canvas2, context2);

const redColorArr = new Float32Array(256);
for (let i = 0; i <= 255; i++) {
    redColorArr[i] = i * 0.299 / 255;
}
const greenColorArr = new Float32Array(256);
for (let i = 0; i <= 255; i++) {
    greenColorArr[i] = i * 0.587 / 255;
}
const blueColorArr = new Float32Array(256);
for (let i = 0; i <= 255; i++) {
    blueColorArr[i] = i * 0.114 / 255;
}
const greyColorArr = new Float32Array(256);
for (let i = 0; i <= 255; i++) {
    greyColorArr[i] = i / 255;
}

// 纵向排列的
function getVertexIndexV(r, c, hRange) {
    return c * hRange + r;
}

function imgToModel(draw, isGray) {
    let { w, h, padding, cubeSize, data } = makeDataForModel(draw);

    // 添加点
    let height = cubeSize * (h + 1) + padding + padding;
    let halfHeight = height * 0.5;

    // 计算点的数量
    let wRange = w + 2;
    let hRange = h + 2;
    let n_vertices = wRange * hRange + 8;
    let vertices = new Float32Array(n_vertices * 3);

    console.time("pixel2depth");
    // 中间的变化点
    let left = padding - 0.5;
    let v_index = 0;
    if (isGray) {
        for (let i = -1; i <= w; i++) {
            let top = padding - halfHeight;
            for (let j = -1; j <= h; j++) {
                let grey = 0;
                if (i >= 0 && i < w && j >= 0 && j < h) {
                    let index = (j * w + i) * 4;
                    grey = greyColorArr[data.data[index]];
                }
                vertices[v_index] = left;
                vertices[v_index + 1] = grey;
                vertices[v_index + 2] = top;
                top += cubeSize;
                v_index += 3;
            }
            left += cubeSize;
        }
    } else {
        for (let i = -1; i <= w; i++) {
            let top = padding - halfHeight;
            for (let j = -1; j <= h; j++) {
                let grey = 0;
                if (i >= 0 && i < w && j >= 0 && j < h) {
                    let index = (j * w + i) * 4;
                    grey = redColorArr[data.data[index]] + greenColorArr[data.data[index + 1]] + blueColorArr[data.data[index + 2]];
                }
                vertices[v_index] = left;
                vertices[v_index + 1] = grey;
                vertices[v_index + 2] = top;
                top += cubeSize;
                v_index += 3;
            }
            left += cubeSize;
        }
    }
    // console.timeEnd("pixel2depth");
    // 四个顶点
    let aIndex = v_index / 3;
    vertices[v_index] = -0.5;
    vertices[v_index + 1] = 0;
    vertices[v_index + 2] = -halfHeight;
    v_index += 3;
    let bIndex = aIndex + 1;
    vertices[v_index] = -0.5;
    vertices[v_index + 1] = 0;
    vertices[v_index + 2] = halfHeight;
    v_index += 3;
    let cIndex = bIndex + 1;
    vertices[v_index] = 0.5;
    vertices[v_index + 1] = 0;
    vertices[v_index + 2] = halfHeight;
    v_index += 3;
    let dIndex = cIndex + 1;
    vertices[v_index] = 0.5;
    vertices[v_index + 1] = 0;
    vertices[v_index + 2] = -halfHeight;
    v_index += 3;

    // 三角形
    let n_tris = (wRange - 1) * (hRange - 1) * 2;
    n_tris += (wRange + hRange) * 2;
    n_tris += 10;
    if (draw.pillar === "type-1") n_tris -= 2;
    let indices = new Array(n_tris * 3);
    let i_index = 0;
    for (let i = 0; i < wRange - 1; i++) {
        for (let j = 0; j < hRange - 1; j++) {
            let a = getVertexIndexV(j, i, hRange); // i * hRange + j; // i, j
            let b = getVertexIndexV(j + 1, i, hRange); // i * hRange + j + 1; // i, j + 1
            let c = getVertexIndexV(j + 1, i + 1, hRange); // (i + 1) * hRange + j + 1; // i + 1, j + 1
            let d = getVertexIndexV(j, i + 1, hRange); // (i + 1) * hRange + j; // i + 1, j
            indices[i_index] = a;
            indices[i_index + 1] = b;
            indices[i_index + 2] = c;
            i_index += 3;
            indices[i_index] = a;
            indices[i_index + 1] = c;
            indices[i_index + 2] = d;
            i_index += 3;
        }
    }

    indices[i_index] = aIndex;
    indices[i_index + 1] = bIndex;
    indices[i_index + 2] = getVertexIndexV(0, 0, hRange);
    i_index += 3;
    for (let i = 1; i < hRange; i++) {
        let a = getVertexIndexV(i - 1, 0, hRange); // i - 1;
        let b = getVertexIndexV(i, 0, hRange); // i;
        indices[i_index] = b;
        indices[i_index + 1] = a;
        indices[i_index + 2] = bIndex;
        i_index += 3;
    }
    indices[i_index] = bIndex;
    indices[i_index + 1] = cIndex;
    indices[i_index + 2] = getVertexIndexV(hRange - 1, 0, hRange);
    i_index += 3;
    for (let i = 1; i < wRange; i++) {
        let b = getVertexIndexV(hRange - 1, i, hRange); // wRange * (hRange - 1) + i;
        let a = getVertexIndexV(hRange - 1, i - 1, hRange);
        indices[i_index] = b;
        indices[i_index + 1] = a;
        indices[i_index + 2] = cIndex;
        i_index += 3;
    }
    indices[i_index] = cIndex;
    indices[i_index + 1] = dIndex;
    indices[i_index + 2] = getVertexIndexV(hRange - 1, wRange - 1, hRange);
    i_index += 3;
    for (let i = hRange - 1; i >= 1; i--) {
        let a = getVertexIndexV(i, wRange - 1, hRange); // wRange * (i - 1) + wRange - 1;
        let b = getVertexIndexV(i - 1, wRange - 1, hRange); // wRange * i + wRange - 1;
        indices[i_index] = b;
        indices[i_index + 1] = a;
        indices[i_index + 2] = dIndex;
        i_index += 3;
    }
    indices[i_index] = dIndex;
    indices[i_index + 1] = aIndex;
    indices[i_index + 2] = getVertexIndexV(0, wRange - 1, hRange);
    i_index += 3;
    for (let i = wRange - 1; i >= 1; i--) {
        let a = getVertexIndexV(0, i, hRange); // wRange * (i - 1) + wRange - 1;
        let b = getVertexIndexV(0, i - 1, hRange); // wRange * i + wRange - 1;
        indices[i_index] = b;
        indices[i_index + 1] = a;
        indices[i_index + 2] = aIndex;
        i_index += 3;
    }

    // 下面的点：四个点
    let downY = -draw.thickness;
    vertices[v_index] = -0.5;
    vertices[v_index + 1] = downY;
    vertices[v_index + 2] = -halfHeight;
    v_index += 3;
    vertices[v_index] = -0.5;
    vertices[v_index + 1] = downY;
    vertices[v_index + 2] = halfHeight;
    v_index += 3;
    vertices[v_index] = 0.5;
    vertices[v_index + 1] = downY;
    vertices[v_index + 2] = halfHeight;
    v_index += 3;
    vertices[v_index] = 0.5;
    vertices[v_index + 1] = downY;
    vertices[v_index + 2] = -halfHeight;
    v_index += 3;
    let aDownIndex = dIndex + 1;
    let bDownIndex = aDownIndex + 1;
    let cDownIndex = bDownIndex + 1;
    let dDownIndex = cDownIndex + 1;

    // 四个壁
    indices[i_index] = aIndex;
    indices[i_index + 1] = aDownIndex;
    indices[i_index + 2] = bDownIndex;
    i_index += 3;
    indices[i_index] = aIndex;
    indices[i_index + 1] = bDownIndex;
    indices[i_index + 2] = bIndex;
    i_index += 3;
    // 对于类型一支柱，下面的面去除
    if (draw.pillar !== "type-1") {
        indices[i_index] = bIndex;
        indices[i_index + 1] = bDownIndex;
        indices[i_index + 2] = cDownIndex;
        i_index += 3;
        indices[i_index] = bIndex;
        indices[i_index + 1] = cDownIndex;
        indices[i_index + 2] = cIndex;
        i_index += 3;
    }
    indices[i_index] = cIndex;
    indices[i_index + 1] = cDownIndex;
    indices[i_index + 2] = dDownIndex;
    i_index += 3;
    indices[i_index] = cIndex;
    indices[i_index + 1] = dDownIndex;
    indices[i_index + 2] = dIndex;
    i_index += 3;
    indices[i_index] = dIndex;
    indices[i_index + 1] = dDownIndex;
    indices[i_index + 2] = aDownIndex;
    i_index += 3;
    indices[i_index] = dIndex;
    indices[i_index + 1] = aDownIndex;
    indices[i_index + 2] = aIndex;
    i_index += 3;

    // 构造底
    indices[i_index] = aDownIndex;
    indices[i_index + 1] = dDownIndex;
    indices[i_index + 2] = cDownIndex;
    i_index += 3;
    indices[i_index] = aDownIndex;
    indices[i_index + 1] = cDownIndex;
    indices[i_index + 2] = bDownIndex;
    i_index += 3;
    currentBaseBegin = aDownIndex;

    let geom = new THREE.BufferGeometry();
    geom.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
    geom.setIndex(indices);

    // geom = geom.toNonIndexed();
    // geom.computeVertexNormals();

    return { geom };
}


function getDrawSize(draw) {
    if (!draw.image) {
        return null;
    }
    // const paddingReal = 3;
    // const padding = paddingReal / draw.width * image.naturalWidth;
    // 计算边距：换算成为像素，保证物理尺寸为1.5毫米
    // 尺寸固定：500x500
    const imageWidth = draw.imageWidth;
    let fontSize = draw.fontSize * imageWidth / draw.width * 0.1;//字号
    //console.log('fontsize', draw.fontSize, draw.width, fontSize, imageWidth, draw.imageWidth);
    let imageHeight = Math.round(draw.image.naturalHeight / draw.image.naturalWidth * imageWidth);
    let textData = null;
    let fullHeight = imageHeight;
    if (draw.useText) {
        canvas2.width = imageWidth;
        textData = textDrawer.breakText(draw.text, fontSize);
        fullHeight = Math.round(fullHeight + textData.height);
    }
    const paddingReal = 1.5;
    const padding = paddingReal / draw.width;
    let cubeSize = (1.0 - padding - padding) / (imageWidth + 1);

    // 支撑部分的数据
    let height = cubeSize * (fullHeight + 1) + padding + padding;
    let rad = draw.degree / 180 * Math.PI; // 弯折角度
    let pillarLen = Math.max(45 / draw.width, height * Math.cos(rad));

    return { w: imageWidth, h2: fullHeight, h: imageHeight, padding, cubeSize, textData, fontSize, rad, pillarLen, height };
}

export function makeDataForModel(draw) {
    let image = draw.image;
    let { w, h, h2, padding, cubeSize, textData, fontSize } = getDrawSize(draw);
    canvas2.width = w;
    canvas2.height = h2;
    context2.fillStyle = "#000000";
    context2.fillRect(0, 0, w, h2);

    context2.drawImage(image, 0, 0, w, h);

    if (draw.useText && draw.text) {
        textDrawer.drawText(textData, fontSize);
        //console.log('draw text', textData, fontSize);
    }

    let data = context2.getImageData(0, 0, w, h2);

    if (draw.blur) {
        data = meanBlur(data, draw.blur);
    }

    return { w, h: h2, padding, cubeSize, data };
}

function meanBlur(imgData, r) {
    let data = imgData.data;
    let width = imgData.width;
    let height = imgData.height;
    let resultImageData = new ImageData(width, height);
    for (let i = 0; i < width; i++) {
        for (let j = 0; j < height; j++) {
            let sum = 0;
            let N = 0;
            for (let k = i - r; k < i + r; k++) {
                for (let l = j - r; l < j + r; l++) {
                    if (k >= 0 && k < width && l >= 0 && l < height) {
                        let index = (l * width + k) * 4;
                        let grey = data[index] * 0.299 + data[index + 1] * 0.587 + data[index + 2] * 0.114;
                        sum += grey;
                        N++;
                    }
                }
            }
            sum /= N;

            let ii = (j * width + i) * 4;
            // //console.log(ii, sum);
            resultImageData.data[ii] = sum;
            resultImageData.data[ii + 1] = sum;
            resultImageData.data[ii + 2] = sum;
        }
    }
    return resultImageData;
}

function makeNewPillar(draw, drawSize) {
    if (currentPillarMesh != null) {
        currentGroup.remove(currentPillarMesh);
        currentPillarMesh.geometry.dispose();
        currentPillarMesh = null;
    }

    // 背面支撑
    // 类型一：弯折
    let pillarGeom;
    let { rad, pillarLen } = drawSize;
    if (draw.pillar === 'type-1') {
        // const  rad = draw.radian / 180 * Math.PI;
        let t = draw.thickness / draw.width; // 总厚度
        let realR = draw.thickness + 1;
        const r = realR / draw.width; // 弯折处的旋转半径：外侧
        // 构造方法：拼接法，背板独立存在
        let shape = new THREE.Shape();
        // shape.moveTo(0, 0.01);
        // shape.lineTo(0, 0);
        shape.moveTo(0, 0);
        let endRad = Math.PI * 2 - rad;
        shape.absarc(r, 0, r, Math.PI, endRad, false);
        let x = r + r * Math.cos(endRad);
        let y = r * Math.sin(endRad);
        x += pillarLen * Math.sin(rad);
        y += pillarLen * Math.cos(rad);
        shape.lineTo(x, y);
        x -= t * Math.cos(rad);
        y += t * Math.sin(rad);
        shape.lineTo(x, y);
        x -= pillarLen * Math.sin(rad);
        y -= pillarLen * Math.cos(rad);
        shape.lineTo(x, y);
        shape.absarc(r, 0, r - t, endRad, Math.PI, true);

        let vertices = [];
        let points = shape.extractPoints(36).shape;
        let ps1 = points.map(v => new THREE.Vector3(v.x, v.y, 0));
        let ps2 = points.map(v => new THREE.Vector3(v.x, v.y, 1));
        addBoundNotClose(vertices, ps1, ps2);

        const faces = THREE.ShapeUtils.triangulateShape(points, []);
        // //console.log("faces", faces);
        faces.forEach(f => {
            vertices.push(points[f[0]].x, points[f[0]].y, 0);
            vertices.push(points[f[2]].x, points[f[2]].y, 0);
            vertices.push(points[f[1]].x, points[f[1]].y, 0);
        });
        faces.forEach(f => {
            vertices.push(points[f[0]].x, points[f[0]].y, 1);
            vertices.push(points[f[1]].x, points[f[1]].y, 1);
            vertices.push(points[f[2]].x, points[f[2]].y, 1);
        });

        pillarGeom = new THREE.BufferGeometry();
        pillarGeom.setAttribute("position", new THREE.BufferAttribute(new Float32Array(vertices), 3));
        pillarGeom.rotateY(Math.PI * 0.5);
        pillarGeom.rotateX(-Math.PI * 0.5);
        pillarGeom.computeVertexNormals();
        draw.radian = rad;
    }

    currentPillarMesh = new THREE.Mesh(pillarGeom, material);
    currentGroup.add(currentPillarMesh);
}

function updateReliefPartPositionAndRotation(draw, drawSize) {
    // 对于浮雕部分，直接缩放即可
    let scale = draw.width;
    currentMesh.scale.set(scale, draw.height, scale);
    // 打底部分，需要修改位置
    let positionArray = currentMesh.geometry.attributes.position.array;
    let begin = currentBaseBegin * 3;
    for (let i = begin; i < positionArray.length; i += 3) {
        positionArray[i + 1] = -draw.thickness / draw.height;
    }
    currentMesh.geometry.attributes.position.needsUpdate = true;
    currentMesh.geometry.computeVertexNormals();
    // 如果弯折角度变化，需要重新计算底部
    let { rad } = drawSize; // 倾斜
    currentGroup.rotation.x = rad;
}

function updatePillarPositionAndRotation(draw, drawSize) {
    let { height } = drawSize;
    let scale = draw.width;
    currentPillarMesh.position.set(
        -0.5 * scale,
        0,
        0.5 * height * scale
    );
    currentPillarMesh.scale.set(scale, scale, scale);
}

function makeGroupIfNeeded() {
    if (!currentGroup) {
        currentGroup = new THREE.Group();
        scene.add(currentGroup);
    } else if (scene.children.indexOf(currentGroup) < 0) {
        scene.add(currentGroup);
    }
}

export function updateMesh(draw) {
    makeGroupIfNeeded();
    updateCurrentMesh(draw);
    renderCount += 2;
}

function addBoundNotClose(vertexes, poly1, poly2) {
    let v2_1 = poly1[0];
    let v2_2 = poly2[0];
    for (let i = 1; i < poly1.length; i++) {
        let v1_1 = poly1[i];
        let v1_2 = poly2[i];
        addRect(vertexes, v2_1, v1_1, v1_2, v2_2);

        v2_1 = v1_1;
        v2_2 = v1_2;
    }
}

function updateCurrentMesh(draw) {
    // 仔细检查每一项，确定更新方案
    // 1. 是否创建新的浮雕部分
    let createNewReliefPart = false; // 重建浮雕网格几何体
    let updateInnerPart = false; // 更新内部区域
    let updateFullPart = false; // 更新整个区域
    let createNewPillar = false; // 创建新的支撑
    let size1 = getDrawSize(currentDraw); // 旧的绘制尺寸
    let size2 = getDrawSize(draw); // 新的绘制尺寸
    if (size1 === null) {
        createNewReliefPart = true;
        createNewPillar = true;
    } else {
        if (size1.w === size2.w && size1.h2 === size2.h2) {
            if (size1.padding === size2.padding) {
                updateInnerPart = true;
            } else {
                updateFullPart = true;
            }
        } else {
            createNewReliefPart = true;
        }

        if (currentDraw.thickness === draw.thickness && size1.rad === size2.rad && size1.pillarLen === size2.pillarLen) {
            createNewPillar = false;
        } else {
            createNewPillar = true;
        }
    }

    //console.log(createNewReliefPart, updateInnerPart, updateFullPart, createNewPillar, size1, size2);

    if (createNewReliefPart) {
        if (currentMesh) {
            currentGroup.remove(currentMesh);
            currentMesh.geometry.dispose();
        }
        let { mesh } = makeNewMesh(draw);
        currentMesh = mesh;
        currentGroup.add(currentMesh);
    } else {
        if (updateInnerPart) {
            updateMeshPosition(draw);
        } else if (updateFullPart) {
            updateMeshPosition2(draw);
        }
    }

    if (createNewPillar) {
        makeNewPillar(draw, size2);
    }

    updatePillarPositionAndRotation(draw, size2);
    updateReliefPartPositionAndRotation(draw, size2);

    currentDraw.image = draw.image;
    currentDraw.width = draw.width;
    currentDraw.height = draw.height;
    currentDraw.thickness = draw.thickness;
    currentDraw.degree = draw.degree;
    currentDraw.blur = draw.blur;
    currentDraw.useText = draw.useText;
    currentDraw.text = draw.text;
    currentDraw.fontSize = draw.fontSize;
    currentDraw.pillar = draw.pillar;
    currentDraw.imageWidth = draw.width;
}

function updateMeshPosition(draw, isGray) {
    //console.log('updateMeshPosition');
    console.time("updateMeshPosition");
    let { w, h, data } = makeDataForModel(draw);
    //console.log('w, h, data', w, h, data);

    let positionArray = currentMesh.geometry.attributes.position.array;
    let vIndex = 0;
    if (isGray) {
        for (let i = -1; i <= w; i++) {
            for (let j = -1; j <= h; j++) {
                if (i >= 0 && i < w && j >= 0 && j < h) {
                    let index = (j * w + i) * 4;
                    let grey = greyColorArr[data.data[index]];
                    positionArray[vIndex + 1] = grey;
                }
                vIndex += 3;
            }
        }
    } else {
        for (let i = -1; i <= w; i++) {
            for (let j = -1; j <= h; j++) {
                if (i >= 0 && i < w && j >= 0 && j < h) {
                    let index = (j * w + i) * 4;
                    let grey = redColorArr[data.data[index]] + greenColorArr[data.data[index + 1]] + blueColorArr[data.data[index + 2]];
                    positionArray[vIndex + 1] = grey;
                }
                vIndex += 3;
            }
        }
    }

    currentMesh.geometry.attributes.position.needsUpdate = true;
    currentMesh.geometry.computeVertexNormals();

    // console.timeEnd("updateMeshPosition");
}

function updateMeshPosition2(draw, isGray) {
    //console.log('updateMeshPosition2');
    let { w, h, padding, cubeSize, data } = makeDataForModel(draw);

    let positionArray = currentMesh.geometry.attributes.position.array;
    let vIndex = 0;
    let left = padding - 0.5;
    let height = cubeSize * (h + 1) + padding + padding;
    let halfHeight = height * 0.5;
    if (isGray) {
        for (let i = -1; i <= w; i++) {
            left += cubeSize;
            let top = padding - halfHeight;
            for (let j = -1; j <= h; j++) {
                top += cubeSize;
                positionArray[vIndex] = left;
                positionArray[vIndex + 2] = top;
                if (i >= 0 && i < w && j >= 0 && j < h) {
                    let index = (j * w + i) * 4;
                    let grey = greyColorArr[data.data[index]];
                    positionArray[vIndex + 1] = grey;
                }
                vIndex += 3;
            }
        }
    } else {
        for (let i = -1; i <= w; i++) {
            left += cubeSize;
            let top = padding - halfHeight;
            for (let j = -1; j <= h; j++) {
                top += cubeSize;
                positionArray[vIndex] = left;
                positionArray[vIndex + 2] = top;
                if (i >= 0 && i < w && j >= 0 && j < h) {
                    let index = (j * w + i) * 4;
                    let grey = redColorArr[data.data[index]] + greenColorArr[data.data[index + 1]] + blueColorArr[data.data[index + 2]];
                    positionArray[vIndex + 1] = grey;
                }
                vIndex += 3;
            }
        }
    }
    positionArray[vIndex + 2] = -halfHeight;
    vIndex += 3;
    positionArray[vIndex + 2] = halfHeight;
    vIndex += 3;
    positionArray[vIndex + 2] = halfHeight;
    vIndex += 3;
    positionArray[vIndex + 2] = -halfHeight;
    vIndex += 3;
    positionArray[vIndex + 2] = -halfHeight;
    vIndex += 3;
    positionArray[vIndex + 2] = halfHeight;
    vIndex += 3;
    positionArray[vIndex + 2] = halfHeight;
    vIndex += 3;
    positionArray[vIndex + 2] = -halfHeight;
    vIndex += 3;
    currentMesh.geometry.attributes.position.needsUpdate = true;
    currentMesh.geometry.computeVertexNormals();
}

function makeNewMesh(draw) {
    let { geom } = imgToModel(draw);
    return {
        mesh: new THREE.Mesh(geom, material)
    };
}

// 两个多边形之间的壁
function addBound(vertexes, poly1, poly2) {
    let v2_1 = poly1[poly1.length - 1];
    let v2_2 = poly2[poly2.length - 1];
    for (let i = 0; i < poly1.length; i++) {
        let v1_1 = poly1[i];
        let v1_2 = poly2[i];
        addRect(vertexes, v2_1, v1_1, v1_2, v2_2);

        v2_1 = v1_1;
        v2_2 = v1_2;
    }
}

// 将一个矩形转换为两个三角形
function addRect(vertexes, a, b, c, d) {
    addTriangle(vertexes, a, b, c);
    addTriangle(vertexes, a, c, d);
}

// 将一个三角形加入顶点数组
function addTriangle(vertexes, a, b, c) {
    vertexes.push(a.x, a.y, a.z, b.x, b.y, b.z, c.x, c.y, c.z);
}





// WEBPACK FOOTER //
// ./src/views/reliefOrnaments/scripts/initThree.js